(function() {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').config(Config);

  function Config($stateProvider) {
    $stateProvider
      .state('dashboard', {
        url: "/dashboard",
        templateUrl: 'module/corregedoria/dashboard/dashboard.html',
        controller: 'DashboardController',
        controllerAs: 'vm',
      });
  }

})();